import { Component, OnInit } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { AltEnderecoComponent } from './alt-endereco/alt-endereco.component';
import { AltRepresLegalComponent } from './alt-repres-legal/alt-repres-legal.component';
import { AltSenhaComponent } from './alt-senha/alt-senha.component';
import { AltContatoComponent } from './alt-contato/alt-contato.component';
import { AssinaturaEletronicaComponent } from './assinatura-eletronica/assinatura-eletronica.component';
import { DadosPessoaisComponent } from './dados-pessoais/dados-pessoais.component'
import { DadosAssociadoComponent } from './dados-associado/dados-associado.component';
import { TermosComponent } from './termos/termos.component';
import { BeneficiarioComponent } from './beneficiario/beneficiario.component';
declare var $: any

@Component({
    selector: 'app-cadastro',
    templateUrl: './cadastro.component.html',
    styleUrls: ['./cadastro.component.css'],
    imports: [BeneficiarioComponent, ReactiveFormsModule, AltEnderecoComponent, AltRepresLegalComponent, AltSenhaComponent, AltContatoComponent, AssinaturaEletronicaComponent, DadosPessoaisComponent, DadosAssociadoComponent, TermosComponent]
})
export class CadastroComponent implements OnInit {
  
  itemRepresLegal: boolean = false;
  itemDadosAssociado: boolean = false;

  constructor(private cadastro: CadastroService, route: ActivatedRoute) { 
    let fragment: string = route.snapshot.fragment;

    if(fragment != null){
      setTimeout(()=>{

        var classe = '.btn-'+fragment.replace("#", '');
        $(classe).click();
  
      }, 800);
    }

  }

  ngOnInit() {

  }
 

}
